{
    "FormEngineSelectElement": {
        "title": "Select"
    },
    "mask": {
        "FormEngineSelectElement": {
            "groupTitle": "Select",
            "datasource": "Options",
            "datasourceExpressions": "Options Filter",
            "showError": "Show Error",
            "showDefaultOption": "Show Default Option",
            "defaultOptionLabel": "Default Option Label",
            "defaultOptionLabelPlaceholder": "Select…",
            "searchable": "Searchable",
            "placeholder": "Placeholder",
            "controlType": "Appearance",
            "controlTypes": {
                "native": "Native",
                "advanced": "Advanced"
            }
        }
    }
}